import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { BASE_ORG_TOKEN } from '../tokens/selected-org.token';
import { switchMap, take, map } from 'rxjs';

export const baseTenantInterceptor: HttpInterceptorFn = (req, next) => {
  const baseOrg$ = inject(BASE_ORG_TOKEN);

  return baseOrg$.pipe(
    take(1),
    map((baseOrg) => baseOrg?.id || null),
    switchMap((tenantId) => {
      const modifiedReq = tenantId
        ? req.clone({ setHeaders: { 'x-base-tenant-id': tenantId } })
        : req;
      return next(modifiedReq);
    })
  );
};
